export const getAvatarImageName = (deviceId: string) =>
  `avatar-${deviceId}.png`;
